export default {
    fsmRoute_modal_delete_title: "Delete Route Points",
    fsmRoute_modal_delete_point: "Are you sure you want delete all points on the route?, It is not possible to save a route without points.",
    fsmRoute_modal_delete_success: "Points deleted succesfully"
}